import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { setAccessToken } from "../../../core/redux/action";
import ImageWithBasePath from "../../../core/img/imagewithbasebath";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { all_routes } from "../../../Router/all_routes";
import { registerNormal } from '../../../apirapper/user.ts';
import { APIAuthenticateSSO } from '../../../api/authSSO.ts';
import Loader from "../../../feature-module/loader/loader";
// import { insertTransaction } from '../../../apirapper/payments.ts';


const SubscriptionPlan = () => {
  const route = all_routes;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const [selectedPlan, setSelectedPlan] = useState("");
  
  const [selectedGateway, setSelectedGateway] = useState("COD"); // Default to COD
  const [referenceNumber, setReferenceNumber] = useState("");
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false); 

  const handleReferenceNumberChange = (e) => {
    setReferenceNumber(e.target.value);
  };
  const generateTransactionID = () => {
    return Math.floor(Math.random() * 1000000000).toString(); // Generate a random transaction ID
  };
  const validateForm = () => {
    const errors = {};

    if (!selectedPlan) {
      errors.selectedPlan = "Please select a plan";
    }

    if (selectedGateway === "Bank Transfer" && !referenceNumber) {
      errors.referenceNumber = "Reference number is required for bank transfer";
    }

    setErrors(errors);

    return Object.keys(errors).length === 0;
  };
  const getPlanAmount = (plan) => {
    switch (plan) {
      case "Basic Plan":
        return 300.00;
      case "Standard Plan":
        return 500.00;
      case "Premium Plan":
        return 800.00;
      default:
        return 0;
    }
  };
  const handleSubmit  = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      setLoading(true);
      const previousformData = location.state;

      // Log form data to console
      let currentDate = new Date();

      // Add one year to the current date
      let nextYearDate = new Date(currentDate);
      nextYearDate.setFullYear(currentDate.getFullYear() + 1);
      
      const transactionID = generateTransactionID();
      const amount = getPlanAmount(selectedPlan);
    
      previousformData.subscriptionPlan = {}
      previousformData.subscriptionPlan = {
        selectedPlan,
        transactionID
      }
      try {
      const tenant = await registerNormal(previousformData);
      console.log('tenant',tenant);
      if(tenant != null)
        {
          //call login or AUTH
          const response = await APIAuthenticateSSO({
            username: previousformData.email,
            password: previousformData.password
          });
          if (response.status?.toString() !== '200') {
            throw new Error('Authentication failed');
          }
          const accessToken = response.response.authentication.access_token;
          if (accessToken) {
            localStorage.setItem('accessToken',accessToken);
            localStorage.setItem('access_token',accessToken);
            dispatch(setAccessToken(accessToken));
            console.log('accessToken',accessToken);
            console.log('amount',amount);
/*
            const obj = {
              "transaction_id": transactionID,
              "merchantId": null,
              "subscription": {
                  "subscriptionId": selectedPlan,
                  "validityPeriod": nextYearDate,
                  "info": selectedPlan
              },
              "billing": {
                  "interval": "yearly",
                  "invoiceId": ""
              },
              "gateway": "manual",
              "amount": amount,//have to change it
              "currency": "USD",
              "transactionStatus": "pending",
              "transactionType": selectedGateway,
              "transactionReference": referenceNumber?referenceNumber:null,
              "paymentGatewayResponse": null,
              // "fraudScore": 5,
              "paymentMethodToken": "",
              "createdBy": "admin",//have to change it
              "note": ""
            };
            console.log('obj',obj)*/
      
            // const res = insertTransaction(obj)
            // console.log('res',res);
          
            // Redirect to dashboard
            navigate(route.dashboard);
          }
       //   console.log('previousformData',previousformData);
  
        }
    } catch (error) {
      setLoading(false);
    
        const errors = {};
        errors.generalError = error.response.data.message;

        console.log('errors.selectedPlan',errors.generalError);

        if (Object.keys(errors).length > 0) {
          setErrors(errors);
          return;
        }
        setErrors({});

      }
      setLoading(false);
    }
  };

  return (
    <div className="main-wrapper">
      <div className="account-content">
        <div className="login-wrapper">
          <div className="login-img">
            <ImageWithBasePath src="assets/img/authentication/login02.png" alt="img" />
          </div>
      
          <div className="login-content">
            <form onSubmit={handleSubmit} style={{ width: "80%" }}>
            {loading && <div className="loader">  <Loader /></div>}
              <div className="login-userset">
                <div className="login-logo logo-normal">
                  <ImageWithBasePath src="assets/img/logo.png" alt="img" />
                </div>
                <Link to={route.dashboard} className="login-logo logo-white">
                  <ImageWithBasePath
                    src="assets/img/logo-white.png"
                    alt="img"
                  />
                </Link>
                <div className="login-userheading">
                <h3>Profile -{">"} Store Address -{">"} ID Verification -{">"} Subscription Plan</h3>
                </div>
                <div className="form-login">
                  <label>Choose Your Plan</label>
                  <div className="form-addons">
                    <select
                      value={selectedPlan}
                      onChange={(e) => setSelectedPlan(e.target.value)}
                      className="form-control"
                    >
                      <option value="">Select Plan</option>
                      <option value="Basic Plan">Basic Plan (300 USD)</option>
                      <option value="Standard Plan">Standard Plan (500 USD)</option>
                      <option value="Premium Plan">Premium Plan (800 USD)</option>
                    </select>
                    <ImageWithBasePath
                      src="assets/img/icons/user-icon.svg"
                      alt="img"
                    />
                  </div>
                  {errors.selectedPlan && (
                    <p className="text-danger">{errors.selectedPlan}</p>
                  )}
                </div>
                <div className="login-userheading">
                  <h3>Payment Gateways</h3>
                </div>
                <div className="form-login">
                  <label>Payment Type</label>
                  <div className="form-addons">
                    <select
                      value={selectedGateway}
                      onChange={(e) => setSelectedGateway(e.target.value)}
                      className="form-control"
                    >
                      <option value="COD">COD</option>
                      <option value="Bank Transfer">Bank Transfer</option>
                    </select>
                    <ImageWithBasePath
                      src="assets/img/icons/user-icon.svg"
                      alt="img"
                    />
                  </div>
                </div>

                {selectedGateway === "Bank Transfer" && (
                  <div className="card">
                    <div className="card-body">
                      <h5 className="card-title">Bank Transfer Details</h5>
                      <div className="form-group">
                        <label>Account Number</label>
                        <p>1234567890</p>
                      </div>
                      <div className="form-group">
                        <label>Account Name</label>
                        <p>Crowd Craft</p>
                      </div>
                      <div className="form-group">
                        <label>Bank Name</label>
                        <p>HBL</p>
                      </div>
                      <div className="form-group">
                        <label>Reference Number</label>
                        <input
                          type="text"
                          value={referenceNumber}
                          onChange={handleReferenceNumberChange}
                          className="form-control"
                        />
                        {errors.referenceNumber && (
                          <p className="text-danger">{errors.referenceNumber}</p>
                        )}
                      </div>
                    </div>
                  </div>
                )}
                 
                <div className="form-login">
                <div>
                {errors.generalError && (
                    <p className="text-danger">{errors.generalError}</p>
                  )}
                  </div>
                  <button type="submit" className="btn btn-login">
                    Submit
                  </button>
                </div>
                

                <div className="my-4 d-flex justify-content-center align-items-center copyright-text">
                  <p>Copyright © 2024 WizzTech. All rights reserved</p>
                </div>
              </div>
            </form>
          </div>
         
        </div>
      </div>
    </div>
  );
};

export default SubscriptionPlan;
